<template>
  <div>
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'vue-chartjs';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default {
  extends: Bar,
  components: {
    Bar,
  },
  props: {
    dados: {
      type: Array,
      required: true,
      default: () => [],
    },
    titulo: {
      type: String,
      default: 'Gráfico de Barras',
    },
    cor: {
      type: String,
      default: '#008000',
    },
  },
  data() {
    return {
      chartData: {
        labels: this.dados.map((item) => item.status),
        datasets: [
          {
            label: this.titulo,
            data: this.dados.map((item) => item.quantidade),
            backgroundColor: this.cor,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Status',
              font: {
                weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            ticks: {
              precision: 0,
            },
            title: {
              display: true,
              text: 'Quantidade',
              font: {
                weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
        },
      },
    };
  },
  watch: {
    dados: {
      handler(newData) {
        this.chartData = {
          labels: newData.map((item) => item.status),
          datasets: [
            {
              label: this.titulo,
              data: newData.map((item) => item.quantidade),
              backgroundColor: this.cor,
            },
          ],
        };
      },
      immediate: true,
    },
  },
  methods: {
    updateChart() {
      if (this.$refs.chart) {
        this.$refs.chart.update();
      }
    },
  },
};
</script>
